// ----
// This is where all of the site-specific JS goes. This is the site's main JS file, so make your JS defensive.
// It's created using the JS Module Pattern (http://addyosmani.com/resources/essentialjsdesignpatterns/book/#modulepatternjavascript)
// Usage: SCM.SiteJS.functionName();  Can be used anywhere in the application.
// ----

var SCM = SCM || {};

// ----
// Where all modules get initialized
// ----
// A closure around doc.ready, window.load, window resize, and Ajax Complete so we can safely use $
(function ($, undefined) {

    // Document Ready Event: DOM fully loaded
    $(document).ready(function () {
        SCM.Logging.init();
        SCM.JqueryMigrateLogger.init();
        SCM.gdprCookieBanner.init();
        SCM.ToolboxGetCitations && SCM.ToolboxGetCitations.init && SCM.ToolboxGetCitations.init();
        SCM.Modals && SCM.Modals.init && SCM.Modals.init();
        SCM.ScholarlyiQ && SCM.ScholarlyiQ.init && SCM.ScholarlyiQ.init();
        // Hack to set the force auto login cookie when clicking
        // the SEG member sign in link for referring URL access
        // REMOVE AS SOON AS WE NO LONGER HAVE THAT LINK
        $('.site-menu-item a.nav-link:contains("SEG Member Log In")').click(function () {
            var date = new Date();
            // 1 hour * 60 minutes * 60 seconds * 1000 milliseconds
            date.setTime(date.getTime() + 1 * 60 * 60 * 1000);
            var expires = '; expires=' + date.toGMTString();
            var path = '; path=/economicgeology';
            //Strictly Neccesary Cookie
            document.cookie = 'ForceAutoLogin=AutoLogin=GeoScienceWorld' + expires + path;
        });

        // Hacking a label for GeoRef Record coordinates.xslt label - can't be added via XSLT due to the way it's stored in the DB, CSS doesn't work.
        var $firstCoordSet = $('.geoRefRecordSummary .georefSection .gr-coordinates').filter(':first');
        $firstCoordSet.addClass('labeled');
        if ($('.widget-ArticleAiLayAbstract').length) {
            SCM.SharedWidgets.ArticleAiLayAbstract && SCM.SharedWidgets.ArticleAiLayAbstract.init();
        }
    });

    // used on map results
    $(document).ajaxStop(function () {
        $('.map-overlay').removeClass('covered');
    });

})(jQuery);